import React from 'react';
import { motion } from 'framer-motion';
import Image from 'next/image';
import ContentText from '@/Components/ContentText';
import ContentTitle from '@/Components/ContentTitle';
export default function UseCaseCard({ placeholder, title, description, id }) {
  return (
    <motion.div
      layout
      className={
        'snap-start w-full rounded  border-slate-200 grid md:flex ' +
        (id % 2 === 0 ? ' md:flex-row ' : ' md:flex-row-reverse ')
      }
    >
      <div
        className={
          'md:w-1/2 flex flex-col  place-items-center ' + (id % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse')
        }
      >
        <div className="flex justify-center">
          <Image
            sizes="(max-width: 768px) 100vw,
              (max-width: 1200px) 50vw,
              33vw"
            height={200}
            width={200}
            src={placeholder}
            alt={title}
            className="rounded-lg w-[60%] md:w-[70%] border-2 border-black  "
          />
        </div>
      </div>

      <article className="md:w-1/2 flex flex-col p-6 justify-between align-baseline min-h-[55%]">
        <div className="w-full h-full flex flex-col gap-2 md:gap-5 justify-center">
          <p className="text-2xl md:text-4xl text-gray-400 font-extrabold">{`0${id + 1}.`}</p>
          <ContentTitle text={title} />
          <ContentText text={description} />
        </div>
      </article>
    </motion.div>
  );
}
